import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "ms-3" };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "ms-3" };
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold fs-4 mb-4" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "d-flex justify-content-between" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = { for: "createOrderRequestCompany" };
const _hoisted_12 = { class: "form-floating mb-3" };
const _hoisted_13 = { for: "createOrderRequestTitle" };
const _hoisted_14 = { class: "form-floating mb-3" };
const _hoisted_15 = { for: "createOrderRequestFirstname" };
const _hoisted_16 = { class: "form-floating mb-3" };
const _hoisted_17 = { for: "createOrderRequestLastname" };
const _hoisted_18 = { class: "form-floating mb-3" };
const _hoisted_19 = { for: "createOrderRequestEmail" };
const _hoisted_20 = { class: "form-floating mb-3" };
const _hoisted_21 = { for: "createOrderRequestPhone" };
const _hoisted_22 = { class: "form-floating mb-3" };
const _hoisted_23 = ["value"];
const _hoisted_24 = { for: "createOrderRequestLang" };
const _hoisted_25 = { class: "form-floating mb-3" };
const _hoisted_26 = ["value"];
const _hoisted_27 = { for: "country" };
const _hoisted_28 = { class: "form-check mb-1" };
const _hoisted_29 = {
    class: "form-check-label",
    for: "createOrderRequestCreateUserAccount"
};
const _hoisted_30 = { class: "form-text mb-3" };
const _hoisted_31 = { key: 0 };
const _hoisted_32 = { class: "form-floating mb-3" };
const _hoisted_33 = { for: "createOrderRequestPassword" };
const _hoisted_34 = { class: "form-floating mb-3" };
const _hoisted_35 = { for: "createOrderRequestPasswordConfirmation" };
const _hoisted_36 = {
    key: 0,
    class: "fw-bold text-danger"
};
const _hoisted_37 = { key: 1 };
const _hoisted_38 = { class: "table mb-3" };
const _hoisted_39 = { class: "form-floating mb-3" };
const _hoisted_40 = ["value"];
const _hoisted_41 = { for: "country" };
const _hoisted_42 = { class: "form-floating mb-3" };
const _hoisted_43 = { for: "createOrderRequestMessage" };
const _hoisted_44 = { class: "form-check mb-3" };
const _hoisted_45 = ["innerHTML"];
const _hoisted_46 = {
    key: 2,
    type: "submit",
    class: "btn btn-primary fw-bold d-inline-flex align-items-center mb-4"
};
const _hoisted_47 = { class: "ms-2" };
const _hoisted_48 = { key: 1 };
const _hoisted_49 = { class: "mb-5" };
import { onMounted, ref } from 'vue';
import axios from 'axios';
import { useForm, usePage } from '@inertiajs/vue3';
import { responseMessages } from '@/Composables/responseMessages';
import { loadTenantConfigs } from '../Composables/standardFunctions';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
import ContextModal from './ContextModal.vue';
import CustomerLoginAndRegistrationForm from '@/Shared/CustomerLoginAndRegistrationForm.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderRequest',
    props: {
        tenantId: String,
        configurationId: String,
        productsAmount: {
            type: Number,
            default: 100
        }
    },
    setup(__props) {
        const { t } = useI18n();
        const { trans } = useTrans();
        let { showErrorSwal, showSuccessSwal } = responseMessages();
        const props = __props;
        const createOrderRequestModal = ref();
        const userLoginModal = ref();
        onMounted(async () => {
            //load configs
            imprintUrl.value = await loadTenantConfigs('imprint_url');
            privacyUrl.value = await loadTenantConfigs('privacy_url');
            tocUrl.value = await loadTenantConfigs('toc_url');
            cancellationRightUrl.value = await loadTenantConfigs('cancellation_right_url');
            loadOrderRequest();
        });
        const user = ref(usePage().props.auth.user);
        const customer = ref(usePage().props.auth.customer);
        const languages = usePage().props.languages;
        const countries = usePage().props.countries;
        const imprintUrl = ref('');
        const privacyUrl = ref('');
        const tocUrl = ref('');
        const cancellationRightUrl = ref('');
        const orderRequestSet = ref(false);
        const createOrderRequestForm = useForm({
            company: null,
            title: null,
            firstname: null,
            lastname: null,
            email: null,
            phone: null,
            lang: languages.length > 0 ? languages[0].code : null,
            countryId: countries.length > 0 ? countries[0].id : null,
            message: null,
            createUserAccount: false,
            password: null,
            passwordConfirmation: null
        });
        function loadUserData() {
            axios.get(route('configurator.userLoader.load'))
                .then(function (response) {
                user.value = response.data.user;
                customer.value = response.data.customer;
                userLoginModal.value.close();
                createOrderRequestModal.value.open();
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadOrderRequest() {
            axios.post(route('configurator.orderRequests.show', props.configurationId))
                .then(function (response) {
                if (response.data.orderRequest != null) {
                    orderRequestSet.value = response.data.orderRequest.isRequestType;
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function createOrderRequest() {
            axios.post(route('configurator.orderRequests.store', props.configurationId), {
                amount: props.productsAmount,
                company: createOrderRequestForm.company,
                title: createOrderRequestForm.title,
                firstname: createOrderRequestForm.firstname,
                lastname: createOrderRequestForm.lastname,
                email: createOrderRequestForm.email,
                phone: createOrderRequestForm.phone,
                lang: createOrderRequestForm.lang,
                country_id: createOrderRequestForm.countryId,
                message: createOrderRequestForm.message,
                create_user_account: createOrderRequestForm.createUserAccount,
                password: createOrderRequestForm.password,
                password_confirmation: createOrderRequestForm.passwordConfirmation
            })
                .then(function (response) {
                if (response.status == 200) {
                    orderRequestSet.value = true;
                    createOrderRequestModal.value.close();
                    showSuccessSwal(t('Vielen Dank für Ihre Anfrage! Wir werden uns zeitnah mit Ihnen in Verbindung setzen.'));
                }
                else {
                    showErrorSwal(response.data);
                }
            })
                .catch(function (error) {
                console.log(error);
                showErrorSwal(error);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (user.value == null || user.value.isCustomer)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "w-100 btn btn-lg btn-primary fw-bold d-inline-flex align-items-center justify-content-center",
                        onClick: _cache[0] || (_cache[0] = ($event) => (createOrderRequestModal.value.open()))
                    }, [
                        (!orderRequestSet.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                                _cache[15] || (_cache[15] = _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    height: "24",
                                    fill: "currentColor",
                                    class: "bi bi-envelope-check",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", { d: "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z" }),
                                    _createElementVNode("path", { d: "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686" })
                                ], -1)),
                                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('Anfrage stellen')), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (orderRequestSet.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                _cache[16] || (_cache[16] = _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    height: "24",
                                    fill: "currentColor",
                                    class: "bi bi-check2-circle",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                    _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                ], -1)),
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('Anfrage gestellt')), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(ContextModal, {
                    ref_key: "createOrderRequestModal",
                    ref: createOrderRequestModal,
                    size: 'lg'
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(t)('Anfrage stellen')), 1),
                        _createElementVNode("div", null, [
                            (!orderRequestSet.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (user.value == null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createElementVNode("p", null, _toDisplayString(_unref(t)('Sie haben bereits ein Nutzerkonto? Als eingeloggter Nutzer können Sie Anfragen und Bestellungen wesentlich schneller durchführen.')), 1),
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("button", {
                                                    class: "btn btn-primary mb-3",
                                                    type: "button",
                                                    onClick: _cache[1] || (_cache[1] = ($event) => (userLoginModal.value.open()))
                                                }, _toDisplayString(_unref(t)('Ich habe bereits ein Nutzerkonto')), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(createOrderRequest, ["prevent"])
                                    }, [
                                        (user.value == null)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        id: "createOrderRequestCompany",
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createOrderRequestForm).company) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(createOrderRequestForm).company]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)('Firma')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_12, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        id: "createOrderRequestTitle",
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(createOrderRequestForm).title) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(createOrderRequestForm).title]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)('Titel')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_14, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        id: "createOrderRequestFirstname",
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(createOrderRequestForm).firstname) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(createOrderRequestForm).firstname]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(t)('Vorname')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_16, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        id: "createOrderRequestLastname",
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(createOrderRequestForm).lastname) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(createOrderRequestForm).lastname]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(t)('Nachname')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_18, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "email",
                                                        class: "form-control",
                                                        id: "createOrderRequestEmail",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(createOrderRequestForm).email) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(createOrderRequestForm).email]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(t)('E-Mail')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_20, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        id: "createOrderRequestPhone",
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(createOrderRequestForm).phone) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(createOrderRequestForm).phone]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(t)('Telefon')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_22, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "createOrderRequestLang",
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(createOrderRequestForm).lang) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: language.code
                                                            }, _toDisplayString(language.name), 9, _hoisted_23));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(createOrderRequestForm).lang]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)('Sprache')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_25, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "country",
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(createOrderRequestForm).countryId) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (country) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: country.id
                                                            }, _toDisplayString(country.name), 9, _hoisted_26));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(createOrderRequestForm).countryId]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(t)('Lieferland')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_28, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        value: "1",
                                                        id: "createOrderRequestCreateUserAccount",
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(createOrderRequestForm).createUserAccount) = $event))
                                                    }, null, 512), [
                                                        [_vModelCheckbox, _unref(createOrderRequestForm).createUserAccount]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(t)('Benutzer-Account erstellen?')), 1)
                                                ]),
                                                _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(t)('Ein Benutzer-Account ermöglicht schnellere Anfragen & Bestellungen, sowie die einfache Verwaltung sämtlicher Konfigurationen, Anfragen und Bestellungen.')), 1),
                                                (_unref(createOrderRequestForm).createUserAccount)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                        _createElementVNode("div", _hoisted_32, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "password",
                                                                class: "form-control",
                                                                id: "createOrderRequestPassword",
                                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(createOrderRequestForm).password) = $event)),
                                                                required: ""
                                                            }, null, 512), [
                                                                [_vModelText, _unref(createOrderRequestForm).password]
                                                            ]),
                                                            _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)('Passwort')), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_34, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "password",
                                                                class: "form-control",
                                                                id: "createOrderRequestPasswordConfirmation",
                                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(createOrderRequestForm).passwordConfirmation) = $event)),
                                                                required: ""
                                                            }, null, 512), [
                                                                [_vModelText, _unref(createOrderRequestForm).passwordConfirmation]
                                                            ]),
                                                            _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(t)('Passwort wiederholen')), 1)
                                                        ]),
                                                        (_unref(createOrderRequestForm).password != '' && _unref(createOrderRequestForm).passwordConfirmation != '' && _unref(createOrderRequestForm).password != _unref(createOrderRequestForm).passwordConfirmation)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_unref(t)('Passwörter stimmen nicht überein')), 1))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (user.value != null && customer.value != null)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                _createElementVNode("p", null, _toDisplayString(_unref(t)('Kontaktdaten lassen sich flexibel in Ihrem Nutzeraccount anpassen.')), 1),
                                                _createElementVNode("table", _hoisted_38, [
                                                    _createElementVNode("tbody", null, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, _toDisplayString(_unref(t)('Firma')), 1),
                                                            _createElementVNode("td", null, _toDisplayString(customer.value.company), 1)
                                                        ]),
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, _toDisplayString(_unref(t)('Ansprechpartner')), 1),
                                                            _createElementVNode("td", null, _toDisplayString(customer.value.firstname) + " " + _toDisplayString(customer.value.lastname), 1)
                                                        ]),
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, _toDisplayString(_unref(t)('E-Mail')), 1),
                                                            _createElementVNode("td", null, _toDisplayString(customer.value.email), 1)
                                                        ]),
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, _toDisplayString(_unref(t)('Telefon')), 1),
                                                            _createElementVNode("td", null, _toDisplayString(customer.value.phone), 1)
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_39, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "country",
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(createOrderRequestForm).countryId) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (country) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: country.id
                                                            }, _toDisplayString(country.name), 9, _hoisted_40));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(createOrderRequestForm).countryId]
                                                    ]),
                                                    _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(t)('Lieferland')), 1)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_42, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                class: "form-control",
                                                id: "createOrderRequestMessage",
                                                style: { "height": "100px" },
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(createOrderRequestForm).message) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createOrderRequestForm).message]
                                            ]),
                                            _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(t)('Optionale Nachricht')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_44, [
                                            _cache[17] || (_cache[17] = _createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "createOrderRequestTermsConfirmation",
                                                required: ""
                                            }, null, -1)),
                                            _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "createOrderRequestTermsConfirmation",
                                                innerHTML: _unref(trans)('Ich habe die {tocUrlT} und die {privacyUrlT} gelesen und bin damit einverstanden.', {
                                                    tocUrlT: `<a href='${tocUrl.value}'>${_unref(t)('AGBs')}</a>`,
                                                    privacyUrlT: `<a href='${privacyUrl.value}'>${_unref(t)('Datenschutzerklärung')}</a>`
                                                })
                                            }, null, 8, _hoisted_45)
                                        ]),
                                        (!_unref(createOrderRequestForm).createUserAccount || (_unref(createOrderRequestForm).password == _unref(createOrderRequestForm).passwordConfirmation))
                                            ? (_openBlock(), _createElementBlock("button", _hoisted_46, [
                                                _cache[18] || (_cache[18] = _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-send-check",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372zm-2.54 1.183L5.93 9.363 1.591 6.602z" }),
                                                    _createElementVNode("path", { d: "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686" })
                                                ], -1)),
                                                _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(t)('Anfrage absenden')), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 32)
                                ]))
                                : _createCommentVNode("", true),
                            (orderRequestSet.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('Ihre Anfrage ist bereits bei uns eingegangen.')), 1),
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('Wir werden uns zeitnah mit Ihnen in Verbindung setzen.')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 512),
                _createVNode(ContextModal, {
                    ref_key: "userLoginModal",
                    ref: userLoginModal,
                    size: 'sm'
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_49, [
                            _createVNode(CustomerLoginAndRegistrationForm, {
                                tenantId: props.tenantId,
                                allowRegistration: false,
                                onLoggedIn: loadUserData
                            }, null, 8, ["tenantId"])
                        ])
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
